/**
 * Ordered list of employee survey steps.
 *
 * Each entry drives the progress bar and the Next/Back buttons in the
 * step wizard. The slug matches the URL param `/employee/step/:slug`.
 *
 * Skip rules reference PRD §5a conditional logic (kept here as prose so
 * the prototype visibly explains when a step would be hidden in prod).
 */
export const STEPS = [
  { slug: 'employment', label: 'About you', skipWhen: null },
  { slug: 'working-pattern', label: 'Working pattern', skipWhen: null },
  { slug: 'wfh-equipment', label: 'Home office', skipWhen: 'wfh_days === 0' },
  { slug: 'lighting', label: 'Lighting', skipWhen: 'wfh_days === 0' },
  { slug: 'heating', label: 'Heating', skipWhen: 'wfh_days === 0' },
  { slug: 'cooling', label: 'Cooling', skipWhen: 'wfh_days === 0' },
  { slug: 'renewable', label: 'Energy source', skipWhen: 'wfh_days === 0' },
  { slug: 'commuting', label: 'Commuting', skipWhen: 'commute_days === 0' },
  { slug: 'review', label: 'Review', skipWhen: null },
];

export const stepIndex = (slug) => STEPS.findIndex((s) => s.slug === slug);

export const stepProgress = (slug) => {
  const i = stepIndex(slug);
  if (i < 0) return 0;
  return Math.round(((i + 1) / STEPS.length) * 100);
};
